"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationApi = exports.AuthenticationApiFactory = exports.AuthenticationApiFp = exports.AuthenticationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
const common_1 = require("../common");
const base_1 = require("../base");
const AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        esyoilAPIEntryPointsAuthenticationBeacon: async (deviceId, deviceType, version, osVersion, manufacturer, model, screentype, options = {}) => {
            const localVarPath = `/v1/auth/beacon`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            if (deviceType !== undefined) {
                localVarFormParams.set('deviceType', deviceType);
            }
            if (version !== undefined) {
                localVarFormParams.set('version', version);
            }
            if (osVersion !== undefined) {
                localVarFormParams.set('osVersion', osVersion);
            }
            if (manufacturer !== undefined) {
                localVarFormParams.set('manufacturer', manufacturer);
            }
            if (model !== undefined) {
                localVarFormParams.set('model', model);
            }
            if (screentype !== undefined) {
                localVarFormParams.set('screentype', screentype);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsAuthenticationInformationAboutMe: async (options = {}) => {
            const localVarPath = `/v1/auth/@me`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsAuthenticationLogin: async (email, password, device, options = {}) => {
            const localVarPath = `/v1/auth/login`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            if (password !== undefined) {
                localVarFormParams.set('password', password);
            }
            if (device !== undefined) {
                localVarFormParams.set('device', device);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsAuthenticationLogout: async (deviceId, options = {}) => {
            const localVarPath = `/v1/auth/logout`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (deviceId !== undefined) {
                localVarFormParams.set('deviceId', deviceId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsAuthenticationRegister: async (email, password, vorname, name, anrede, strasse, zipcode, ort, datenschutz, options = {}) => {
            const localVarPath = `/v1/auth/register`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            if (password !== undefined) {
                localVarFormParams.set('password', password);
            }
            if (vorname !== undefined) {
                localVarFormParams.set('vorname', vorname);
            }
            if (name !== undefined) {
                localVarFormParams.set('name', name);
            }
            if (anrede !== undefined) {
                localVarFormParams.set('anrede', anrede);
            }
            if (strasse !== undefined) {
                localVarFormParams.set('strasse', strasse);
            }
            if (zipcode !== undefined) {
                localVarFormParams.set('zipcode', zipcode);
            }
            if (ort !== undefined) {
                localVarFormParams.set('ort', ort);
            }
            if (datenschutz !== undefined) {
                localVarFormParams.set('datenschutz', datenschutz);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsAuthenticationResendRegistrationEmail: async (email, options = {}) => {
            const localVarPath = `/v1/auth/resend-confirmation`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsAuthenticationVerify: async (token, options = {}) => {
            const localVarPath = `/v1/auth/verify`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (token !== undefined) {
                localVarFormParams.set('token', token);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AuthenticationApiAxiosParamCreator = AuthenticationApiAxiosParamCreator;
const AuthenticationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthenticationApiAxiosParamCreator(configuration);
    return {
        async esyoilAPIEntryPointsAuthenticationBeacon(deviceId, deviceType, version, osVersion, manufacturer, model, screentype, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsAuthenticationBeacon(deviceId, deviceType, version, osVersion, manufacturer, model, screentype, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsAuthenticationInformationAboutMe(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsAuthenticationInformationAboutMe(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsAuthenticationLogin(email, password, device, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsAuthenticationLogin(email, password, device, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsAuthenticationLogout(deviceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsAuthenticationLogout(deviceId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsAuthenticationRegister(email, password, vorname, name, anrede, strasse, zipcode, ort, datenschutz, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsAuthenticationRegister(email, password, vorname, name, anrede, strasse, zipcode, ort, datenschutz, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsAuthenticationResendRegistrationEmail(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsAuthenticationResendRegistrationEmail(email, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsAuthenticationVerify(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsAuthenticationVerify(token, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AuthenticationApiFp = AuthenticationApiFp;
const AuthenticationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthenticationApiFp(configuration);
    return {
        esyoilAPIEntryPointsAuthenticationBeacon(deviceId, deviceType, version, osVersion, manufacturer, model, screentype, options) {
            return localVarFp.esyoilAPIEntryPointsAuthenticationBeacon(deviceId, deviceType, version, osVersion, manufacturer, model, screentype, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsAuthenticationInformationAboutMe(options) {
            return localVarFp.esyoilAPIEntryPointsAuthenticationInformationAboutMe(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsAuthenticationLogin(email, password, device, options) {
            return localVarFp.esyoilAPIEntryPointsAuthenticationLogin(email, password, device, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsAuthenticationLogout(deviceId, options) {
            return localVarFp.esyoilAPIEntryPointsAuthenticationLogout(deviceId, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsAuthenticationRegister(email, password, vorname, name, anrede, strasse, zipcode, ort, datenschutz, options) {
            return localVarFp.esyoilAPIEntryPointsAuthenticationRegister(email, password, vorname, name, anrede, strasse, zipcode, ort, datenschutz, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsAuthenticationResendRegistrationEmail(email, options) {
            return localVarFp.esyoilAPIEntryPointsAuthenticationResendRegistrationEmail(email, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsAuthenticationVerify(token, options) {
            return localVarFp.esyoilAPIEntryPointsAuthenticationVerify(token, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AuthenticationApiFactory = AuthenticationApiFactory;
class AuthenticationApi extends base_1.BaseAPI {
    esyoilAPIEntryPointsAuthenticationBeacon(deviceId, deviceType, version, osVersion, manufacturer, model, screentype, options) {
        return exports.AuthenticationApiFp(this.configuration).esyoilAPIEntryPointsAuthenticationBeacon(deviceId, deviceType, version, osVersion, manufacturer, model, screentype, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsAuthenticationInformationAboutMe(options) {
        return exports.AuthenticationApiFp(this.configuration).esyoilAPIEntryPointsAuthenticationInformationAboutMe(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsAuthenticationLogin(email, password, device, options) {
        return exports.AuthenticationApiFp(this.configuration).esyoilAPIEntryPointsAuthenticationLogin(email, password, device, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsAuthenticationLogout(deviceId, options) {
        return exports.AuthenticationApiFp(this.configuration).esyoilAPIEntryPointsAuthenticationLogout(deviceId, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsAuthenticationRegister(email, password, vorname, name, anrede, strasse, zipcode, ort, datenschutz, options) {
        return exports.AuthenticationApiFp(this.configuration).esyoilAPIEntryPointsAuthenticationRegister(email, password, vorname, name, anrede, strasse, zipcode, ort, datenschutz, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsAuthenticationResendRegistrationEmail(email, options) {
        return exports.AuthenticationApiFp(this.configuration).esyoilAPIEntryPointsAuthenticationResendRegistrationEmail(email, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsAuthenticationVerify(token, options) {
        return exports.AuthenticationApiFp(this.configuration).esyoilAPIEntryPointsAuthenticationVerify(token, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthenticationApi = AuthenticationApi;
//# sourceMappingURL=authentication-api.js.map